module.exports = __webpack_public_path__ + "static/media/Screen Shot 2023-02-20 at 14.16.14@2x.2023db3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screen Shot 2023-02-20 at 14.16.14@2x.png
// module id = 570
// module chunks = 1